<script>
export default {
    props: {
        'content': {
            required: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// Block.vue?133cebbc